export const errorsFromTanstackForm = (state: any) => {
  const fieldMeta = state.fieldMeta
  const keys = Object.keys(fieldMeta).filter((key) => fieldMeta[key].errors.length)

  return keys.map((key) => ({ fieldName: key, error: fieldMeta[key].errors.join(', ') }))
}

export const errorsFromReactHookForm = (srcErrors: any) => {
  const dstErrors = []
  makeFlattenArrays(srcErrors, '', dstErrors)
  return dstErrors
}

const makeFlattenArrays = (srcErrors: any, prefix = '', dstErrors: any) => {
  for (const key in srcErrors) {
    const currentPrefix = prefix.length ? prefix + '.' + key : key
    if (
      srcErrors.hasOwnProperty(key) &&
      srcErrors[key] !== undefined &&
      srcErrors[key].hasOwnProperty('message') &&
      typeof srcErrors[key].message === 'string'
    ) {
      dstErrors.push({
        fieldName: currentPrefix,
        error: srcErrors[key].message
      })
    } else {
      makeFlattenArrays(srcErrors[key], currentPrefix, dstErrors)
    }
  }
}
